import { Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { Subject, Subscription } from 'rxjs';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSelection, Report, RowActions, SelectionAction, TotalObject } from '../../../dashboard/admin/report/report';
import { BaseRequestService } from '../../services/base-request.service';
import { FindUserConfigService } from '../../services/find-user-config.service';
import { UpdateUserConfigService } from '../../services/update-user-config.service';
import { RequestHelperService } from '../../services/request-helper.service';
import { saveAs } from 'file-saver-es';
import { Router } from '@angular/router';
import { ReportUpdateTableContentHelper } from 'src/app/dashboard/seller/report/services/report-helper.service';
import axios from 'axios';
import { GlobalLoaderService } from '../../services/global-loader.service';

@Component({
  selector: 'app-report-table',
  templateUrl: './report-table.component.html',
  styleUrls: ['./report-table.component.scss']
})

export class ReportTableComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild(MatTable) table!: MatTable<any>;
  @ViewChild("configureTable") configElement: any;

  @Output() paginationEvent = new EventEmitter();
  @Output() toggleFilter = new EventEmitter();
  @Output() selectionActionClick = new EventEmitter();
  @Output() searchChanges = new EventEmitter();
  @Output() rowActionClicked = new EventEmitter();
  @Output() sortClick = new EventEmitter();
  @Output() ExtpendableRowClicke = new EventEmitter();
  @Output() ExtpendableColumnClick = new EventEmitter();
  @Output() cancelAdvancedSalesRequest = new EventEmitter();
  @Input() disableRipple: boolean = false;

  @Input() hasCheckboxes: boolean = false;
  @Input() selectionActions: SelectionAction[] = [];
  @Input() tableName!: string;
  @Input() defaultColumns: string[] = [];
  @Input() columnsDisplayNames: any;
  @Input() data: any;
  @Input() rowsLength: number = 532;
  @Input() hasFilters: boolean = false;
  @Input() tableLoading: boolean = false;
  @Input() rowActions: RowActions[] = [];
  @Input() rowActionKeyName: any;
  @Input() customSelectionRows: CustomSelection[] = [];
  @Input() selection!: SelectionModel<any>;
  @Input() hasSorting: boolean = false;
  @Input() total!: TotalObject;
  @Input() serviceInstance!: BaseRequestService;
  @Input() reportSaveName: any;
  @Input() emptyDataMessage!: string;
  @Input() reportName!: string;
  @Input() ExtpendableColumn!: string;
  @Input() LinkingCoulmns: { [index: string]: any } = {};
  @Input() columnNameToClick!: string;
  @Input() columnTypes: any;
  @Input() hasCancelRequest: boolean = false;
  @Input() usingTableComponent!: string;
  @Input() showReportName;
  @Input() isClickable: boolean = false;
  @Input() identifierKey: any;
  @Input() showTopBar = true;

  identifierArray: any[] = [];
  selectedRowStatus: Array<String> = [];

  isExpansionDetailRow = (row: Object) => {
    return row.hasOwnProperty('detailRow')
  };
  expandedElement: any;
  rowClick() {
    this.ExtpendableRowClicke.emit({ refNum: this.expandedElement[this.ExtpendableColumn] });
  }

  columnClicked(columnValue: any) {
    this.ExtpendableColumnClick.emit({ refNum: columnValue });
  }

  private checkBoxColumnName: string = "select";
  public currentPage = 1;
  public selectedColumns: string[] = [];
  public displayedColumns: any[] = [];
  public dataSource = new MatTableDataSource;
  public numberOfEntries = [5, 10, 15, 20];
  public searchKey: string = '';
  public configVisible = false;
  public searchVisible = false;
  public filterVisible = false;
  public hasActiveSelection: boolean = false;
  public hasRowActions: boolean = true;
  public totalArray: string[] = [];
  public totalKey: string = '';
  subscriptions: Subscription[] = [];
  public hasTotal: boolean = true;
  debouncer: Subject<string> = new Subject<string>();
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    protected gls: GlobalLoaderService,
    private findTableConfig: FindUserConfigService,
    private updateUserConfig: UpdateUserConfigService,
    private rHelper: RequestHelperService,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
    private reportContentHelper: ReportUpdateTableContentHelper,
    protected router: Router
  ) { }

  async ngOnInit() {
    this.reportName = this.tableName;
    this.rHelper.table = this;
    this.dataSource = new MatTableDataSource<any>(this.data);
    if (this.rowActions?.length) {
      this.hasRowActions = true;
    } else {
      this.hasRowActions = false;
    }
    if (this.hasCheckboxes && !this.selection) {
      this.selection = new SelectionModel<any>(true, []);
    }
    if (this.tableName) {
      this.findTableConfig.setParams({
        tablename: this.reportSaveName
          ? this.tableName + this.reportSaveName
          : this.tableName
      });
      const r = await this.findTableConfig.make();
      if (this.defaultColumns) {
        if (r.message === "Not Found" || this.defaultColumns) {
          this.selectedColumns = [...this.defaultColumns];
          this.updateDisplayedColumns();
        } else {
          this.selectedColumns = [...r];
          this.updateDisplayedColumns();
        }
      }
    }
    if (this.selection) {
      this.subscriptions.push(
        this.selection.changed.subscribe(i => {
          if (this.selection) {
            this.hasActiveSelection = this.selection.hasValue();
            if (i['added'].length > 0)
              this.selectedRowStatus.push(i['added'][0]['status']);
            if (i['removed'].length > 0){
              for(let row of i['removed']){
                const index =this.selectedRowStatus.indexOf(row['status'])
                this.selectedRowStatus.splice(index,1)
              }
            }
          }
        })
      );
    }

    if (this.sort)
      this.sort.sortChange.subscribe(val => {
        this.sortClick.emit(val);
      });

    if (this.total) {
      this.totalArray = this.total.columnsToGetTotalOf;
      this.totalKey = this.total.totalKeyColumn;
      this.hasTotal = true;
    }
    this.reportContentHelper.getTableContentData().subscribe((value)=>{
      this.updateContent(value.tableColumns,value.displayTableColumns);
    })
  }

  sortData(val: any) {
    this.sortClick.emit(val);
  }

  getFooterValue(key: any) {
    if (key === this.totalKey) {
      return "Total";
    } else if (this.totalArray.includes(key)) {
      return this.data
        .map((i:any) => i[key])
        .reduce((acc: any, val: any) => Number(acc) + Number(val), 0)
        .toFixed(2);
    } else {
      return "";
    }
  }

  ngOnChanges() {
    this.dataSource = new MatTableDataSource<any>(this.data);
    this.table?.renderRows();
  }

  updateContent(columns: any, display: any) {
    this.columnsDisplayNames = display;
    this.defaultColumns = columns;
    this.selectedColumns = [...this.defaultColumns];
    this.updateDisplayedColumns();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subs => subs.unsubscribe());
  }

  async toggleFilterF() {
    this.filterVisible = !this.filterVisible;
    this.toggleFilter.emit(this.filterVisible);
  }

  isValidUrl(str: any) {
    if (str.productName || str.name || str.merchant || str.businessName || str.shop_name || str.date || str.id){
      return false;
    }
    if (str[`${this.identifierKey}`] && this.identifierArray.indexOf(str[`${this.identifierKey}`]) > -1) {
      return true;
    }
    this.identifierArray.push(str[`${this.identifierKey}`]);
    const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    return !!pattern.test(str);
  }

  async updateUserConfigSelection() {
    this.updateUserConfig.setParams({
      tablename: this.tableName,
      colums: this.selectedColumns
    });
    await this.updateUserConfig.make();
  }

  updateDisplayedColumns() {
    if (this.hasCheckboxes) {
      this.displayedColumns = [
        this.checkBoxColumnName,
        ...this.selectedColumns
      ];
    } else {
      this.displayedColumns = [...this.selectedColumns];
    }

    if (this.hasRowActions) {
      this.displayedColumns.push("actions");
    }
  }

  onSelectColumn(event: any) {
    if (this.selectedColumns.length == 0) {
      //can't be no attributes
      this.selectedColumns = [event.option.value]; // prevent change by return the last removed one
    }
    this.updateDisplayedColumns();
  }

  isAllSelected() {
    const numSelected = this.selection?.selected.length;
    const numRows = this.countSelectable();
    return numSelected === numRows;
  }

  isRowSelectable(row: any) {
    // return false;
    if (this.customSelectionRows.length === 0) {
      return true;
    } else {
      // @ts-ignore
      const result = this.customSelectionRows.find(item => {
        return item.valueIn.indexOf(row[item.colName]) >= 0;
      });
      if (result) {
        return true;
      } else {
        return false;
      }
    }
  }

  countSelectable() {
    let count = 0;
    for (const i of this.data) {
      if (this.isRowSelectable(i)) {
        count++;
      }
    }
    return count;
  }

  ///** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection?.clear()
      : this.dataSource.data.forEach(row => {
        if (this.isRowSelectable(row)) {
          this.selection?.select(row);
        }
      });
  }

  ///** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      // tslint:disable
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
      // tslint:enable
    }
    return `${
      // tslint:disable
      this.selection?.isSelected(row) ? "deselect" : "select"
      // tslint:enable
      } row ${row.position + 1}`;
  }

  configClosed() {
    this.updateDisplayedColumns();
    this.updateUserConfigSelection();
  }

  @HostListener("document:click", ["$event.target"])
  public onClick(targetElement: any) {
    if (this.configElement) {
      // see if clicked element is the target element OR the button
      const clickedInside =
        this.configElement.nativeElement.contains(targetElement) ||
        targetElement.classList.contains("open-button");
      if (!clickedInside && this.configVisible) {
        this.configVisible = false;
        this.configClosed();
      }
    }
  }

  public paginate(event: any) {
    this.paginationEvent.emit(event);
  }

  public selectionActionClickF(name: any) {
    const so = {
      action: name,
      selection: this.selection?.selected
    };
    this.selectionActionClick.emit(so);
    this.selection.clear();
  }

  public async exportAs(type: 'xlsx' | 'pdf' | 'csv') {
    if (this.serviceInstance) {
      const request: Report = this.serviceInstance.getParams();
      const copy: Report = JSON.parse(JSON.stringify(request));
      copy.paginationOptions = undefined;
      copy.export = { type, columns: this.columnsDisplayNames };
      const headers = {
        'Content-Type': 'application/json',
        'x-url': this.router.url.split('?')[0],
      };
      try {
        this.gls.open();
        const res = await axios.post(this.serviceInstance.getPath(), JSON.stringify(copy), {
          headers,
          responseType: 'blob',
          withCredentials: true,
        });
        const fileBlob = new Blob([res.data], { type: res.headers['content-type'] });
        const time = new Date().getTime();
        saveAs(fileBlob, `${this.tableName}_export_${time}.${type}`);
      } finally {
        this.gls.close();
      }
    }
  }

  print() {
    const title =  "Easykash - Your Online Payment Gateway";
    const divToPrint = document.getElementById(this.tableName + "_report").innerHTML;
    if (divToPrint) {
      const iframe = document.createElement('iframe')
      iframe.name = "printFrame";
      iframe.style.position = "absolute";
      iframe.style.top = "-1000000px";
      document.body.appendChild(iframe);
      const idoc = iframe.contentWindow.document;
      idoc.open();
      idoc.write(`<html><head><title>Easykash - Your Online Payment Gateway</title>`);
      idoc.write(`</head><body><h1>${title}</h1><body>${divToPrint}</body></html>`);
      idoc.close();
      setTimeout(function () {
        window.frames["printFrame"].focus();
        window.frames["printFrame"].print();
        document.body.removeChild(iframe);
      }, 500);
    }
  }

  onSearch() {
    this.searchChanges.emit(this.searchKey);
    this.table?.renderRows();
  }

  clearSearchF() {
    this.searchKey = '';
    this.searchChanges.emit(this.searchKey);
    this.table?.renderRows();
  }

  public rowActionClickF(id: any, action: any) {
    //console.log("ID: " + id + "// Action: " + action);
    this.rowActionClicked.emit({ key: id, action: action });
  }

  public selectionToggle(row: any) {
    if (this.selection) {
      this.selection.toggle(row);
    }
  }

  public copyValuesToExcelFormat(objArray: any): string {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    if (!Array.isArray(array))
      array = [array];

    let str = '';
    array.forEach((element: any) => {
      let line = '';
      Object.keys(element).forEach(key => {
        if (line != '') line += '\t'
        const item = element[key];
        line += (typeof item === 'object' && item !== null ? this.copyValuesToExcelFormat(item) : item);
      });
      str += line + '\r\n';
    });

    return str.replace(/("\t\t")/gm, '\t').replace(/(null)/gm, "");
  }

  public copyColumnNames(columnNames: any): string {
    let columns = '';
    Object.keys(columnNames).forEach(key =>
      columns += columnNames[key] + '\t'
    );
    columns += '\r\n';
    return columns;
  }

  public async getCopyToClipBoardData() {
    let result = '';
    let columns: string = this.copyColumnNames(this.columnsDisplayNames);
    try {
      if (this.serviceInstance) {
        const request: Report = this.serviceInstance.getParams();
        const copy: Report = JSON.parse(JSON.stringify(request));
        copy.paginationOptions = undefined;
        const headers = {
          'Content-Type': 'application/json',
          'x-url': this.router.url.split('?')[0],
        };
        await fetch(this.serviceInstance.getPath(), { method: 'POST', headers, body: JSON.stringify(copy) })
          .then(function (response) {
            return response.json()
          });
          let normalizedData;
          if (this.serviceInstance._result.result) {
            normalizedData = this.normalizeData(
              this.serviceInstance._result.result,
              this.columnsDisplayNames
            );
          } else {
            normalizedData = this.normalizeData(
              this.serviceInstance._result.data.result,
              this.columnsDisplayNames
            );
          }
        let columnValues: string = this.copyValuesToExcelFormat(normalizedData);
        result += columns + columnValues;
      }
    } catch (error) {
      throw new Error(error);
    }
    return result;
  }

  private normalizeData(data: any, columns: any) {
    const fromEntries = (arr: any[]) => Object.assign({}, ...Array.from(arr, ([k, v]) => ({ [k]: v })));
    const columnsEntries = Object.entries(columns);
    return data.map((row: any) => this.normalizeRow(row, fromEntries, columnsEntries));
  }

  private normalizeRow(row: { [k: string]: any }, fromEntries: any, columnsEntries: any[]) {
    let normalizedRow = fromEntries(columnsEntries.map(([name, displayName]) => {
      if (row[name] instanceof Date) {
        return [displayName, moment(row[name]).format("MMMM D, YYYY")]
      }
      const rowData = row[name];
      return [displayName, isNaN(rowData) || this.tableName == 'withdrawals' ? rowData : Number(rowData)]
    }));
    return normalizedRow;
  }

  public async copyToClipBoard() {
    let message = '';
    let result = await this.getCopyToClipBoardData();
    try {
      const selBox = document.createElement('textarea') as HTMLTextAreaElement;
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = result;
      document.body.appendChild(selBox);
      selBox.select();
      const success = document.execCommand('copy');
      document.body.removeChild(selBox);
      message = success ? this.translate.instant('Sellers.Products.CopiedToClipboard') : this.translate.instant('Sellers.Products.UnableToCopy');
    } catch (err) {
      message = this.translate.instant('Sellers.Products.UnableToCopy');
    } finally {
      this.snackBar.open(message, '', { duration: 2000 });
    }
  }

  isRowActionDisabled(index: number, action: RowActions) {
    if (action.actions) {
      return this.rowActionsAction(index, action);
    }
    if (!action.actionDisableEnableField) {
      return false;
    }
    const rowEnableDisableFieldValue = this.data[index][action.actionDisableEnableField];
    if (action.actionDisableValues) {
      return action.actionDisableValues.includes(rowEnableDisableFieldValue);
    } else if (action.actionEnableValues) {
      return !action.actionEnableValues.includes(rowEnableDisableFieldValue);
    }
    return false;
  }

  public cancelRequestToParent(indexRow: any) {
    this.cancelAdvancedSalesRequest.emit(this.data[indexRow]["id"]); // send id of advanced sales request to be cancelled
  }

  public determineCondition(action: { actionValue: string; [key: string]: any }) {
    switch (this.usingTableComponent) {
      case "Sales Report":
        const cancelButton = !(this.selectedRowStatus.includes("NEW") || this.selectedRowStatus.includes("FAILED") || this.selectedRowStatus.includes("EXPIRED"));
        const failedButton = this.selectedRowStatus.includes("NEW") && !this.selectedRowStatus.includes("EXPIRED");
        const paidButton = (!this.selectedRowStatus.includes('PAID') && (this.selectedRowStatus.includes("NEW") || this.selectedRowStatus.includes("EXPIRED") || this.selectedRowStatus.includes("FAILED")))
        return (
          (cancelButton  && action.actionValue == "CANCELED") ||
          (failedButton  && action.actionValue == "FAILED") ||
          (paidButton  && action.actionValue == "PAID")
        );
      case "Activation Report":
        const RejectAndAccept = this.selectedRowStatus.includes("INCOMPLETE") || this.selectedRowStatus.includes('REJECT');
        return (
          (RejectAndAccept && action.actionValue == 'DELETE') ||
          !(RejectAndAccept && action.actionValue != 'DELETE')
        )
      case 'SMS Marketing':
        return true;
      default:
        return true;
    }
  }

  private rowActionsAction(index: number, action: RowActions): boolean {
    let retValue = false;
    for (let i = 0; i < action.actions.length; i++) {
      const a = action.actions[i];
      const value = this.data[index][a.field];
      if (a.values.includes(value)) {
        retValue = a.enabled;
        continue;
      }
      retValue = !a.enabled;
      break;
    }
    return !retValue;
  }
}
